import { createAction } from 'redux-actions';

// AUTHORS
export const setCurrentAuthor = createAction('SET_CURRENT_AUTHOR', author => ({ author }));

export const getAuthors = createAction('GET_AUTHORS');
export const getAuthorsSuccess = createAction('GET_AUTHORS_SUCCESS', authors => ({ authors }));
export const getAuthorsFailure = createAction('GET_AUTHORS_FAILURE');

export const getAuthorById = createAction('GET_AUTHOR_BY_ID', id => ({ id }));
export const getAuthorByIdSuccess = createAction('GET_AUTHOR_BY_ID_SUCCESS', author => ({ author }));
export const getAuthorByIdFailure = createAction('GET_AUTHOR_BY_ID_FAILURE');

export const addAuthor = createAction('ADD_AUTHOR', author => ({ author }));
export const addAuthorSuccess = createAction('ADD_AUTHOR_SUCCESS');
export const addAuthorFailure = createAction('ADD_AUTHOR_FAILURE');

export const updateAuthor = createAction('UPDATE_AUTHOR', author => ({ author }));
export const updateAuthorSuccess = createAction('UPDATE_AUTHOR_SUCCESS');
export const updateAuthorFailure = createAction('UPDATE_AUTHOR_FAILURE');

// CATEGORIES

export const getCategoryById = createAction('GET_CATEGORY_BY_ID', id => ({ id }));
export const getCategoryByIdSuccess = createAction('GET_CATEGORY_BY_ID_SUCCESS', category => ({ category }));
export const getCategoryByIdFailure = createAction('GET_CATEGORY_BY_ID_FAILURE');

export const addCategory = createAction('ADD_CATEGORY', category => ({ category }));
export const addCategorySuccess = createAction('ADD_CATEGORY_SUCCESS');
export const addCategoryFailure = createAction('ADD_CATEGORY_FAILURE');

export const updateCategory = createAction('UPDATE_CATEGORY', category => ({ category }));
export const updateCategorySuccess = createAction('UPDATE_CATEGORY_SUCCESS');
export const updateCategoryFailure = createAction('UPDATE_CATEGORY_FAILURE');

// PLACES
export const getPlaces = createAction('GET_PLACES');
export const getPlacesSuccess = createAction('GET_PLACES_SUCCESS', places => ({ places }));
export const getPlacesFailure = createAction('GET_PLACES_FAILURE');

export const getPlaceById = createAction('GET_PLACE_BY_ID', id => ({ id }));
export const getPlaceByIdSuccess = createAction('GET_PLACE_BY_ID_SUCCESS', place => ({ place }));
export const getPlaceByIdFailure = createAction('GET_PLACE_BY_ID_FAILURE');

export const addPlace = createAction('ADD_PLACE', place => ({ place }));
export const addPlaceSuccess = createAction('ADD_PLACE_SUCCESS');
export const addPlaceFailure = createAction('ADD_PLACE_FAILURE');

export const updatePlace = createAction('UPDATE_PLACE', place => ({ place }));
export const updatePlaceSuccess = createAction('UPDATE_PLACE_SUCCESS');
export const updatePlaceFailure = createAction('UPDATE_PLACE_FAILURE');

// TOPICS
export const getTopics = createAction('GET_TOPICS');
export const getTopicsSuccess = createAction('GET_TOPICS_SUCCESS', topics => ({ topics }));
export const getTopicsFailure = createAction('GET_TOPICS_FAILURE');

export const getTopicById = createAction('GET_TOPIC_BY_ID', id => ({ id }));
export const getTopicByIdSuccess = createAction('GET_TOPIC_BY_ID_SUCCESS', topic => ({ topic }));
export const getTopicByIdFailure = createAction('GET_TOPIC_BY_ID_FAILURE');

export const addTopic = createAction('ADD_TOPIC', topic => ({ topic }));
export const addTopicSuccess = createAction('ADD_TOPIC_SUCCESS');
export const addTopicFailure = createAction('ADD_TOPIC_FAILURE');

export const updateTopic = createAction('UPDATE_TOPIC', topic => ({ topic }));
export const updateTopicSuccess = createAction('UPDATE_TOPIC_SUCCESS');
export const updateTopicFailure = createAction('UPDATE_TOPIC_FAILURE');

// NEWS ITEMS
export const setCurrentNewsItem = createAction('SET_CURRENT_NEWS_ITEMS', newsItem => ({ newsItem }));
export const setNewsItemQuery = createAction('SET_CURRENT_NEWS_ITEM_QUERY', query => ({ query }));
export const setNewsItemCount = createAction('SET_CURRENT_NEWS_ITEM_COUNT', count => ({ count }));
export const setNewsItemPage = createAction('SET_CURRENT_NEWS_ITEM_PAGE', offset => ({ offset }));

export const getNewsItems = createAction('GET_NEWS_ITEMS', query => ({ query }));
export const getNewsItemsSuccess = createAction(
  'GET_NEWS_ITEMS_SUCCESS',
  (newsItems, resultsItemCount, resultsPageCount) => ({
    newsItems,
    resultsItemCount,
    resultsPageCount,
  })
);
export const getNewsItemsFailure = createAction('GET_NEWS_ITEMS_FAILURE');

export const enhanceNewsItem = createAction('ENHANCE_NEWS_ITEM', newsItem => ({ newsItem }));
export const enhanceNewsItemSuccess = createAction('ENHANCE_NEWS_ITEM_SUCCESS', newsItem => ({ newsItem }));
export const enhanceNewsItemFail = createAction('ENHANCE_NEWS_ITEM_FAIL', newsItem => ({ newsItem }));

export const getPostById = createAction('GET_POST_BY_ID', (siteId, postId) => ({ siteId, postId }));
export const getPostByIdSuccess = createAction('GET_POST_BY_ID_SUCCESS', post => ({ post }));
export const getPostByIdFailure = createAction('GET_POST_BY_ID_FAILURE');

export const getNewsItemById = createAction('GET_NEWS_ITEM_BY_ID', id => ({ id }));
export const getNewsItemByIdSuccess = createAction('GET_NEWS_ITEM_BY_ID_SUCCESS', newsItem => ({ newsItem }));
export const getNewsItemByIdFailure = createAction('GET_NEWS_ITEM_BY_ID_FAILURE');

export const addNewsItem = createAction('ADD_NEWS_ITEM', newsItem => ({ newsItem }));
export const addNewsItemSuccess = createAction('ADD_NEWS_ITEM_SUCCESS', newsItem => ({ newsItem }));
export const addNewsItemFailure = createAction('ADD_NEWS_ITEM_FAILURE');

export const publishDraftNewsItem = createAction('PUBLISH_DRAFT_NEWS_ITEM', newsItem => ({ newsItem }));
export const publishDraftNewsItemSuccess = createAction('PUBLISH_DRAFT_NEWS_ITEM_SUCCESS');
export const publishDraftNewsItemFailure = createAction('PUBLISH_DRAFT_NEWS_ITEM_FAILURE');

export const updateNewsItem = createAction('UPDATE_NEWS_ITEM', newsItem => ({ newsItem }));
export const updateNewsItemSuccess = createAction('UPDATE_NEWS_ITEM_SUCCESS');
export const updateNewsItemFailure = createAction('UPDATE_NEWS_ITEM_FAILURE');

export const updateEvent = createAction('UPDATE_EVENT', event => ({ event }));
export const updateEventSuccess = createAction('UPDATE_EVENT_SUCCESS');
export const updateEventFailure = createAction('UPDATE_EVENT_FAILURE');

export const getSites = createAction('GET_ALL_CONTENT_SITES');
export const getSitesSuccess = createAction('GET_ALL_CONTENT_SITES_SUCCESS', sites => ({ sites }));
export const getSitesFailure = createAction('GET_ALL_CONTENT_SITES_FAILURE');

export const cloneNewsItem = createAction('CLONE_NEWS_ITEM', (siteId, sectionId, article) => ({
  siteId,
  sectionId,
  article,
}));
export const cloneNewsItemSuccess = createAction('CLONE_NEWS_ITEM_SUCCESS');
export const cloneNewsItemFailure = createAction('CLONE_NEWS_ITEM_FAILURE');

export const tagPost = createAction('TAG_ITEM', (siteId, postId, tags) => ({
  siteId,
  postId,
  tags,
}));
export const tagPostSuccess = createAction('TAG_ITEM_SUCCESS');
export const tagPostFailure = createAction('TAG_ITEM_FAILURE');
